export const DATETIME_FORMATS = {
	TIMESTAMP: 'X',
	FULL_DAY_WITH_YEAR: 'dddd DD MMMM YYYY',
	FULL_DAY_WITH_YEAR_AND_TIME: 'dddd DD MMMM YYYY, HH:mm',
	FULL_DAY: 'dddd DD MMMM',
	SHORT_DAY: 'dddd DD/MM',
	RAW_DATE: 'YYYY-MM-DD',
	DATETIME: 'DD MMMM HH:mm',
	DATETIME_WITH_YEAR: 'DD MMMM YYYY, HH:mm',
	RAW_DATETIME_WITH_YEAR: 'YYYY-MM-DD HH:mm:ss',
	FULL_DATE: 'DD MMMM YYYY',
	DATE: 'DD-MM-YYYY',
	DATE_UNICODE: 'dd-MM-yyyy',
	MONTH_YEAR: 'MMMM-YYYY',
	DAY: 'DD',
	MONTH: 'MMMM',
	YEAR: 'YYYY',
	WEEKDAY: 'dddd',
	TIME: 'HH:mm',
};
